import saveStatusValues from 'constants/status.save'

function action(type, payload) {
    return {
        type,
        payload,
    }
}

//RESOURCE

export function setResource(id, value) {
    return action('SET_RESOURCE', {id, value})
}

export function clearResource(id) {
    return setResource(id, undefined);
}

export function addObjectResource(id, key, value) {
    return action('ADD_OBJECT_RESOURCE', {id, key, value})
}

export function addObjectResources(id, keyValuePairObject) {
    return action('ADD_OBJECT_RESOURCES', {id, keyValuePairObject})
}

//PRIVILEGE

export function setPrivileges(id, value) {
    return action('SET_PRIVILEGES', {id, value})
}

export function clearPrivileges(id) {
    return setPrivileges(id, undefined);
}

//SIGNATURE

export function setSignature(id, value) {
    return action('SET_SIGNATURE', {id, value})
}

export function clearSignature(id) {
    return setSignature(id, undefined);
}

//STORE

function __setStoreValue(id, value) {
    return action('SET_STORE_VALUE', {id, value})
}

function __setStoreMultiValue(obj) {
    return action('SET_STORE_MULTI_VALUE', obj)
}

export function setRedirectWithoutHistoryFunc(func) {
    return __setStoreValue('redirectReplace', func)
}

export function setRedirectFunc(func) {
    return __setStoreValue('redirect', func)
}

export function setClientColors(value) {
    return __setStoreValue('clientColors', value)
}

export function setContrastColors(value) {
    return __setStoreValue('contrast', value)
}

export function setLargeText(value) {
    return __setStoreValue('largeText', value)
}

export function setMenuOpen(value) {
    return __setStoreValue('isMenuOpen', value)
}

export function setSalesNotification(salesNotification) {
    return __setStoreValue('salesNotification', salesNotification)
}

export function clearSalesNotification() {
    return setSalesNotification(undefined)
}

export function setEzamowieniaOauth(ezamowieniaOauth) {
    return __setStoreValue('ezamowieniaOauth', ezamowieniaOauth)
}

export function clearEzamowieniaOauth() {
    return setEzamowieniaOauth(undefined)
}

export function setConfirmCloseStepper(handleConfirm, sectionName, handleSecondConfirm) {
    return __setStoreValue('confirmCloseStepper', {handleConfirm, sectionName, handleSecondConfirm})
}

export function clearConfirmCloseStepper() {
    return __setStoreValue('confirmCloseStepper', undefined)
}

export function setConfirmNotifications(confirmNotification) {
    return __setStoreValue('confirmNotification', confirmNotification)
}
export function clearConfirmNotification() {
    return setConfirmNotifications(undefined)
}

export function setAlertNotifications(alertNotification) {
    return __setStoreValue('alertNotification', alertNotification)
}
export function clearAlertNotification() {
    return setAlertNotifications(undefined)
}
export function setLoadingScreen(loadingScreen) {
    return __setStoreValue('loadingScreen', loadingScreen)
}
export function clearLoadingScreen() {
    return setAlertNotifications(undefined)
}

function __setSaveStatus(value) {
    return __setStoreValue('saveStatus', value)
}

export function setSaveStatusLoading() {
    return __setSaveStatus(saveStatusValues.LOADING)
}

export function setSaveStatusDeleted() {
    return __setSaveStatus(saveStatusValues.DELETE)
}

export function setSaveStatusClosed() {
    return __setSaveStatus(saveStatusValues.CLOSED)
}

export function setSaveStatusDialog() {
    return __setSaveStatus(saveStatusValues.DIALOG)
}

export function setSaveStatusInfo(message) {
    return __setStoreMultiValue({
        saveStatus: saveStatusValues.INFO,
        saveStatusMessage: message,
    })
}

export function setSaveStatusError(errorMessage) {
    return __setStoreMultiValue({
        saveStatus: saveStatusValues.ERROR,
        saveStatusMessage: errorMessage,
    })
}

export function setOpenTutorial(value = true) {
    return __setStoreValue('openTutorial', value)
}

export function setInnerMenuOpen(obj) {
    return {
        type: 'SET_INNER_MENU',
        payload: obj
    }
}

export function setOpenRegisterPopup(value = null) {
    return __setStoreValue('registerPopup', value)
}

//OPEN DEALINGS PARTS FORM
export function setOpenForm(value) {
    return __setStoreValue('openForm', value)
}

//OPEN DEALINGS IMPORTER FORM
export function setOpenImporter(value) {
    return __setStoreValue('openImporter', value)
}

// FORM
export function setForm(id, value) {
    return action('SET_FORM_SUBMIT_FUNC', {id, value})
}

// FORM VALUES
export function setFormValues(id, form, dirty) {
    return action('SET_FORM_VALUES', {id, form, dirty})
}

// FORM AUTO SAVE LOADED
export function setFormDraftLoaded(id, draftLoaded) {
    return action('SET_FORM_DRAFT_LOADED', {id, draftLoaded})
}

export function clearFormValues(id) {
    return action('CLEAR_FORM_VALUES', {id})
}

//AUTHORIZE
export function setAuthorizeCounter() {
    return action('SET_AUTHORIZE_COUNTER');
}

//STEPPER

export function setStepperState(state = null) {
    return action('SET_STEPPER_STATE', state);
}

export function setStepperStateCloseValidator(closeValidationFunction) {
    return action('SET_STEPPER_STATE_CLOSE_VALIDATOR', closeValidationFunction);
}

export function clearStepperStateCloseValidator() {
    return setStepperStateCloseValidator(undefined)
}

export function setStepperStateDeleteFormDraftFunction(deleteFormDraftFunc) {
    return action('SET_STEPPER_STATE_DEL_FORM_DRAFT_FUNCTION', deleteFormDraftFunc);
}

export function clearStepperStateDeleteFormDraftFunction() {
    return setStepperStateDeleteFormDraftFunction(undefined)
}

export function setStepperStateSaveFormDraftFunction(deleteFormDraftFunc) {
    return action('SET_STEPPER_STATE_SAVE_FORM_DRAFT_FUNCTION', deleteFormDraftFunc);
}

export function clearStepperStateSaveFormDraftFunction() {
    return setStepperStateSaveFormDraftFunction(undefined)
}